import React, { useState } from "react";
import { LogoOperadora } from "constants/Logotipo";

// components
import { Row, Col, Spinner } from "reactstrap";

export default function Inicio({ history }) {

  const [showLoading, setshowLoading] = useState(false);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className="content">
        <Row className="mb-2">
          <Col lg="9" md="8" sm="12"><h4 className="mt-0 mb-0">
           Bem Vindo ao DRE TIM! </h4>
           <label className="text-center">Sistema de Demonstração do Resultado do Exercício</label>
           </Col>
          <Col lg="3" md="4" sm="12">
          </Col>
          <Col lg="12" md="12" className="text-center">
              <div className="mb-12" style={{marginTop:'150px'}}>
                  <img src={LogoOperadora()} className="img-logo" height="100px" />
              </div>
          </Col>
        </Row>
      
      </div>
    </>

  );
}